import {responseResolveInterceptor} from './interceptors';
import {formDataToRequestParams, getAxios} from './axios';
import {addAuthTokenData} from './member';

function doPayment(url, {t, cn, exp_month, exp_year, cvv, email, ...rest}) {
    let axios = getAxios({forcedSSL: true});

    axios.interceptors.response.use(responseResolveInterceptor);

    return axios.request({
        url: url,
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData({t, cn, exp_month, exp_year, cvv, email, ...rest}))
    });
}

export function paymentMembership({t, cn, exp_month, exp_year, cvv, email, ...rest}) {
    let formData = {t, cn, exp_month, exp_year, cvv, email};

    if (rest.r) formData.r = rest.r;
    if (rest.message) formData.message = rest.message;
    if (rest.returnPath) formData.return_path = rest.returnPath;

    //return doPayment('/payment/membership/', formData);
    return doPayment('/payment/auth/', formData);
}

export function paymentWallet({t, finalizeGiftId, cn, exp_month, exp_year, cvv, email, ...rest}) {
    let formData = {t, finalizeGiftId, cn, exp_month, exp_year, cvv, email};

    if (rest.returnPath) formData.return_path = rest.returnPath;

    //return doPayment('/payment/wallet/', formData);
    return doPayment('/payment/auth/', formData);
}




// WEBPACK FOOTER //
// ./src/backend-helpers/payment.js